"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _text = _interopRequireDefault(require("@ux/text"));
var _dropdownPillMenu = _interopRequireDefault(require("../../../dropdown-pill-menu"));
var _pillSelection = _interopRequireDefault(require("../../../pill-selection"));
var _attachmentRow = require("./attachment-row");
var _productContent = _interopRequireDefault(require("../../../common/product-content"));
var _configContext = require("../../../context/config-context");
var _functions = require("../../../utils/functions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Local Imports
 */

const Menu = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Menu",
  class: "pc-mqqjrah"
});
const GridContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "GridContainer",
  class: "pc-gicoojm"
});

/**
 * SelectableRow Component.
 *
 * @param {Object} props React props
 * @param {string} props._name Tracking name
 * @param {string} props.layouts The type of row ('dropdown' or 'radio')
 * @param {string} props.rowTitle The title of the row
 * @param {string} props.rowDisclaimer The disclaimer of the row
 * @param {Array} props.items The array of items for the row
 * @param {function} props.handleDropDownChange The function to handle dropdown change
 * @param {function} props.handlePillChange The function to handle pill change
 * @param {bool} props.displayDisable Applies disabled state to the row
 * @param {bool} props.split makes pillSelector into a split mode
 * @param {string} props.partialTheme Partial theme for the row
 * @returns {React.ReactElement} SelectableRow Component
 * @public
 */
function SelectableRow({
  _name,
  layouts,
  rowTitle,
  rowDisclaimer,
  items,
  handleDropDownChange,
  handlePillChange,
  displayDisable,
  partialTheme = 'precheck',
  instancePath,
  ...rest
}) {
  const {
    configData
  } = (0, _configContext.useConfig)();
  const [selectedStates, setSelectedStates] = (0, _react.useState)({});
  const handleSetSelected = (itemInstancePath, newState) => {
    setSelectedStates(prevState => ({
      ...prevState,
      [itemInstancePath]: newState
    }));
  };
  if (!items) {
    return null;
  }
  const renderMenu = () => {
    if (layouts === 'termSelector') {
      return /*#__PURE__*/_react.default.createElement(Menu, null, items?.map((item, index) => /*#__PURE__*/_react.default.createElement(_dropdownPillMenu.default, (0, _extends2.default)({
        key: index
      }, rest, {
        options: item.options,
        onChange: handleDropDownChange,
        _name: _name
      }))));
    } else if (layouts === 'pillSelector') {
      return /*#__PURE__*/_react.default.createElement(Menu, null, items?.map(item => {
        const {
          options,
          split
        } = item;
        const selectedOption = (0, _functions.checkSelectedOptionValue)(configData?.instance, instancePath);
        const initialSelected = typeof selectedStates[instancePath] !== 'undefined' ? selectedStates[instancePath] : options.findIndex(option => option.id === selectedOption);
        return /*#__PURE__*/_react.default.createElement(_pillSelection.default, (0, _extends2.default)({
          key: instancePath
        }, rest, {
          items: options,
          split: split,
          onChange: handlePillChange,
          selected: initialSelected,
          setSelected: newState => handleSetSelected(instancePath, newState),
          partial: partialTheme
        }));
      }));
    }
  };
  const disabledPillSelector = displayDisable && layouts === 'pillSelector';
  const className = `selectable-row-item ${rowTitle ? 'hasBorder' : ''}`;
  return /*#__PURE__*/_react.default.createElement(_attachmentRow.Container, {
    "data-cy": "selectable-row-item",
    className: className
  }, rowTitle && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    "data-cy": "row-title",
    className: "row-title",
    as: "title",
    text: rowTitle,
    size: 5
  }), /*#__PURE__*/_react.default.createElement(GridContainer, {
    className: disabledPillSelector && 'disabled'
  }, /*#__PURE__*/_react.default.createElement(_productContent.default, rest), renderMenu(), rowDisclaimer && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    "data-cy": "product-disclaimer",
    className: "row-disclaimer",
    as: "paragraph",
    text: rowDisclaimer,
    size: -1
  })));
}
var _default = exports.default = SelectableRow;
SelectableRow.propTypes = {
  layouts: _propTypes.default.string,
  rowTitle: _propTypes.default.string,
  rowDisclaimer: _propTypes.default.string,
  items: _propTypes.default.array,
  handleDropDownChange: _propTypes.default.func,
  handlePillChange: _propTypes.default.func,
  displayDisable: _propTypes.default.bool,
  split: _propTypes.default.bool,
  partialTheme: _propTypes.default.string,
  instancePath: _propTypes.default.string,
  _name: _propTypes.default.string
};